export default __webpack_public_path__ + "static/media/ASK.0d6cf33f.svg";